/**
 * 生活特权
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/life_privilege',
    name: 'lifePrivilege',
    component: () => import('@/views/lifePrivilege/entry.vue'),
    children: [
      {
        path: '',
        name: 'lifeIndex',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/lifePrivilege/index.vue'
          ),
        meta: {
          title: '生活特权',
          is_festivalPop: true
        }
      },
      {
        path: '/life_privilege/brand_details',
        name: 'LPbrandDetails',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/lifePrivilege/brandDetailds.vue'
          ),
        meta: {
          title: '品牌详情'
        }
      },
      {
        // 适用门店（与生日专区共用同一页面：城市 tab + 区域分组）
        path: '/life_privilege/store_list',
        name: 'lifePrivilegeStoreList',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/birthday/storeList.vue'
          ),
        meta: {
          title: '适用门店'
        }
      },
      {
        path: '/life_privilege/list',
        name: 'PbrandList',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/lifePrivilege/list.vue'
          ),
        meta: {
          title: '品牌详情'
        }
      }
    ]
  }
];
